import * as colorbox from "jquery-colorbox";
import flatpickr from "flatpickr";
// import stripe from "https://js.stripe.com/v3";
//import { gsap } from "gsap";

// API access token
var apiToken = '5uElciE7JCIMCD4uBEnOSGtyooSjJO3uzunyaYCDYQZL0BTy0xskYQlzYYuo';

// API Access URL
// var url = 'tours.glenfiddich.com';
var url = 'tours.glenfiddich.com';

if ($('#tour_api_url').length) {
	url = $('#tour_api_url').val();
}

// Save data variables
var selectedTourInstance = '', selectedTourDate = '', selectedTourPlaces = '', selectedTourPlacesU18 = 0, tourCost = '', u18, tourNameText, selectedTourTime = '', step1Content;
var loadedTourId, tourAllowsU18, datePicker, validationMessages = [], formData = {};
var tourContainer, navContainer, bookTourContainer, payTourContainer, submitContainer, loading, tourAllowsU18, loadedTourId, tourNameText, tourId, allowsU18, tourDate, selected, tourDateInput, tourTimeSelect, tourPlacesSelect;
var current_country = $("#country_selected").val();

navContainer = $("#navWrapper");
bookTourContainer = $("#bookTourContainer");
payTourContainer = $("#payTourContainer");
submitContainer = $("#submitContainer");
loading = $('.loading');
var domain_host = window.location.protocol + "//" + window.location.host;

let searchParams = new URLSearchParams(window.location.search);
if (searchParams.has('BookingError')) {
	var bData = checkBooking(searchParams.get('payment_intent'), 'error');

	if (searchParams.has('BookingId')) {
		$('.failure-booking-id-container').removeClass('hidden');
		$('.failure-booking-id').html(bData.booking_id);
	}
} else if (searchParams.has('BookingId')) {
	var bData = checkBooking(searchParams.get('payment_intent'), 'success');
	var the_data = bData;
}

function convertBritishDateFormat(date) {
	var d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	return [day, month, year].join('-');
}
function convertNormalDateFormat(date) {
	var d = '';
	var text = date.toString();
	if (text.indexOf('-') > 0) {
		var from = text.split("-");
		d = new Date(from[2], from[1] - 1, from[0]);
	} else {
		d = new Date(date);
	}

	var month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();
	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	return [year, month, day].join('-');
}
function checkIfDate(date) {
	var dateFormat = Date.parse(date)
	if (dateFormat > 0) {
		return true
	} else {
		return false
	}
}


function checkBooking(id, status) {
	$.getJSON("https://" + url + "/api/v1/booking/checkBookingStatus/" + id + "?api_token=" + apiToken).done(function (result) {
		if (!result.booking_error) {
			bookingSuccess(result);
		} else {
			bookingFail(result);
		}
	});
}

function bookingSuccess(response) {
	let returnPath = drupalSettings.path.pathPrefix;
	var successHTML = `<div id="success-booking-container">
	<div class="success-bg-white">
	<h2 class="title_label">Your Tour: </h2>
    <h3 class="success--title">$TourName</h3>
    <div class="date_time_container"><span class="success--date">$BookingDate</span> at <span class="success--time">$TourTime</span></div>
    <div class="price_container">Qty: <span class="success--price_qty">x1:</span><br>Cost: <span class="success--price">$Price</span></div>
    <div class="message_container">Your booking ID is <span class="success--booking_id">$BookingId</span>. You will receive an email confirmation shortly</div>
    <a class="book-home" href="/${returnPath}">Back Home</a>
    </div></div>
`;

	var searchParams = new URLSearchParams(window.location.search);

	$('.slider--title, .title-and-nav').hide();
	var successHeaderHtml = `<h1>Your tour is booked<br>See you soon!</h1>`;

	$('#paragraph__book_tour__1436').hide();
	$('#paragraph__book_tour__2377').hide();
	$('#paragraph__book_tour__2369').hide();
	$('#paragraph__section_hero_simple__2324').hide();
	$('.tour-booking-success').removeClass('hidden');

	$(".book-distillery-tour").removeClass("tour-success").removeClass("tour-failed").addClass("tour-success");
	// $('body').append(successHTML);
	var successContent = $("#success-booking-container").html();
	// $('.collection-whisky-listing').html(successContent).removeClass("collection-whisky-listing").removeClass("slick-initialized").removeClass("slick-slider").addClass("success-container");
	$("#success-booking-container").show();
	$('.paragraph--type--customized-slider-content').find('.content').html(successHeaderHtml);
	$('.paragraph--type--customized-slider-content').find('.content').append(successHTML);
	$('.slick-slider').css('display','none');
	
	// $('.paragraph--type--customized-slider-content').find('.content').hide();
	$('.success--title').html(response.tour_name);
	$('.success--booking_id').html(searchParams.get('gfBookingId'));
	$('.success--date').html(response.booking_date);
	$('.success--time').html(response.tour_time);
	$('.success--price_qty').html('x ' + response.booking_qty);
	$('.success--price').html('£ ' + sessionStorage.getItem("price_structure_value"));
}

function bookingFail(response) {
	var failHTML = `
		<div id="failed-booking-container">
			<p>`+ response.booking_error + `</p>
			<a class="book-home" href="/">Back Home</a>
		</div>
		`;
	var failedHeaderHtml = `<h1>SORRY ORDER FAILED</h1>`;
	$('#paragraph__book_tour__1436').hide();
	$('#paragraph__book_tour__2377').hide();
	$('#paragraph__book_tour__2369').hide();
	$('#paragraph__section_hero_simple__2324').hide();
	// $('body').append(failHTML);

	var sBookingError = searchParams.get('BookingError');

	// $('.failure-booking-reason').html(response.booking_error);
	// $('.failure-booking-id-container').removeClass('hidden');
	// $('.failure-booking-id').html(response.booking_id);


	$(".book-distillery-tour").removeClass("tour-success").removeClass("tour-failed").addClass("tour-failed");
	$('body').append(failHTML);
	var failedContent = $("#failed-booking-container").html();
	$('.collection-whisky-listing').html(failedContent).removeClass("collection-whisky-listing").addClass("failed-container");
	$('.paragraph--type--customized-slider-content').find('.content').html(failedHeaderHtml);

	$('.failure-booking-reason').html(response.booking_error);
	$('.failure-booking-id-container').removeClass('hidden');
	$('.failure-booking-id').html(response.booking_id);

}
var isMobile = false;
var selectedTourId = 0;
$(document).ready(function () {
	
	isMobile = (window.matchMedia("(max-width: 767px)").matches) ? true : false;
	current_country = $("#country_selected").val();
	if ($(".book-distillery-tour").length) {

		$.getJSON("https://" + url + "/api/v1/brand/1/tours?api_token=" + apiToken).done(function (result) {
			result = $(result['data']).sort(sortJsonOrder);
			var currindex = 1;
			$.each(result, function (i, field) {

				if (field['dietary_requirements'] != "") {
					$('#tourDietaryRequirements__holder').show();
					$('#tourDietaryNotes').html(field['dietary_requirements']);
				}

				var html = '<div class="tour">';
				html += '<div class="inner">';
				html += '<div class="top-title">' + field["short_description"] + '</div>';
				html += '<h2 id="theTourName">' + field["name"] + '</h2>';
				html += '<ul><li class="duration"><span class="duration-text">' + field["duration"] + '</span></li><li class="price"><span class="price-text">£' + field["price"] + ' PP</span></li></ul>';

				html += '<div class="white-header buy-link flex items-center"><a href="#bookTourContainer' + field["id"] + '" data-id="' + field["id"] + '" data-u18="' + field["allow_u18"] + '" data-tourname="' + field["name"] + '" class="more-info font-formulacondensed text-[18px] leading-[19px] uppercase border-black border-b-[1px] more-info-click' + currindex + '">Book Now</a></div>';

				html += '<div id="bookTourContainer' + field["id"] + '" class="more-info-lightbox">';
				html += '<form class="desktop-container">';
				html += '<div class="desktop-column first">';
				html += '<h2>Book Your <span id="tourName">' + field["name"].replace('The', '') + '</span></h2><p></p>';


				html += '<div class="feature-container">';
				html += '<div class="feature">';
				html += '<span id="more-taste">' + field["taste"] + ' - </span>';
				html += '<span id="more-duration">' + field["duration"] + ' - </span>';
				html += '<span>&pound;<span id="more-price">' + field["price"] + '</span> PP';
				html += '</div>';
				html += '</div>';


				html += '<div class="tourDateBox">';
				html += '<div id="tourDate" class="section">';
				html += '<label class="box-label" for="tourDateInput' + currindex + '">Select a date:</label>';
				html += '<div class="tour-date-input-holder"><input type="text" id="tourDateInput' + currindex + '" name="date" readonly="readonly"></div>';
				html += '</div>';
				html += '<div id="tourTime" class="section">';
				html += '<label for="tourTimeSelect' + currindex + '" class="box-label"> Select a tour time:</label>';
				html += '<div class="selectField">';
				html += '<select id="tourTimeSelect' + currindex + '" name="time">';
				html += '<!-- JS Populated -->';
				html += '</select>';
				html += '</div>';
				html += '</div>';
				html += '<div id="tourPlaces" class="section">';
				html += '<label for="tourPlacesSelect' + currindex + '" class="box-label"> Select how many places you would like to book:</label> ';
				html += '<div class="selectField">';
				html += '<select id="tourPlacesSelect' + currindex + '" name="places">';
				html += '<!-- JS Populated -->';
				html += '</select>';
				html += '</div>';
				html += '</div>';
				html += '<div id="tourPlacesU18" class="section" style="display: none;">';
				html += '<label for="tourPlacesU18Select"><span>4</span> Please confirm how many of your group are under 18 (if any):</label> ';
				html += '<div class="selectField">';
				html += '<select id="tourPlacesU18Select" name="u18places">';
				html += '<option value="0">0</option>';
				html += '<!-- JS Populated -->';
				html += '</select>';
				html += '</div>';
				html += '<span class="desc">Under 18s go free of charge</span>';
				html += '</div>';
				// html += '<div class="step-1-error hidden">You have selected an invalid amount of tickets.</div>';
				html += '<button class="book tour-payment tcm-cta" data-cta-action="Continue Booking to Personal Information" data-cta-event="ctaClicks" data-cta-label="Continue Booking">Continue Booking</button>';
				html += '</div>';
				html += '<p class="todaysTours">Today’s tours cannot be booked online, please telephone <a href="tel:+441340822211">01340 822 211</a></p>';

				html += '<div class="content">';

				html += '<p></p>';
				html += '<div class="more-desc">';
				html += '<h3 class="about-tour">About this tour</h3>';
				html += '<img class="more-image" src="' + field["image"] + '" alt="' + field["name"] + '" />' + field["description"];
				html += '<p></p>';

				html += '</div>';
				html += '<button class="book tour-payment mobile-only tcm-cta" data-cta-action="Continue Booking to Personal Information" data-cta-event="ctaClicks" data-cta-label="Continue Booking">Continue Booking</button>';
				html += '</div>';

				html += '</div> ';

				html += '</div>';
				html += '</form>';
				html += '</div>';

				html += '</div></div>';
				$('#tourContainer' + currindex).append(html);
				$('#tourDateInput' + currindex).on('focus', function () {
					$('#tourDateInput' + currindex).css('opacity', 0);
					// $('.flatpickr-calendar.inline').css('display','block');
				});

				loading.hide();
				colorboxInit(currindex);
				currindex++;
			});


			$(document).on('change', '#cboxLoadedContent #tourCountrySelect', function (e) {
				if ($("#cboxLoadedContent #tourCountrySelect").val() == "GB") {
					$('#cboxLoadedContent #alchemetrics-checkbox').removeClass('hidden');
				} else {
					$('#cboxLoadedContent #alchemetrics-checkbox').addClass('hidden');
				}
			});

		}).fail(function (result) {
			var html = '<p class="error">Sorry, we couldn\'t connect to the booking server right now. <br/> Please retry in a few minutes.</p>';
			$('#tourContainer1').html(html);
			$('#tourContainer2').html(html);
		});

		//asdf123
		$('#cboxLoadedContent').on('change', function () {
		});
		$(document).on('click', '#paragraph__booking_navigation_item__3417 a', function (e) {
			e.preventDefault();
		});

		$(document).on('click', '#paragraph__booking_navigation_item__3426 a', function (e) {
			e.preventDefault();
		});
		function loadTours(tourId = null) {
			$.getJSON("https://" + url + "/api/v1/brand/1/tours?api_token=" + apiToken).done(function (result) {
				var html = "";
				html += "<option value=''>Select Tour</option>";
				jQuery.each(result.data, function (i, field) {
					html += '<option value="' + field['id'] + '" data-cost="' + field['price'] + '" data-capacity="' + field['capacity'] + '"' + selected + '>';
					html += field["name"];
					html += '</option>';
				});
				$("#cboxLoadedContent #tourSelect").html(html);
			});
		}
		function loadTour(tourId) {
			$("#cboxLoadedContent #tourSelect").each(function (i) {
				if ($(this).val == tourId) {

				}
			});
		}

		function loadTourTimesPlaces(tourId) {
			if (tourId == null || tourId == '') {
				$("#cboxLoadedContent #tourDateInput").val('');
				$("#cboxLoadedContent #tourTimeSelect").html('');
			} else {
				var tourDateInput = $('#tourDateInput');
				var tourTimeSelect = $('#tourTimeSelect');
				var tourPlacesSelect = $('#tourPlacesSelect');
				var selectedTourDate = "";
				$.getJSON("https://" + url + "/api/v1/tourinstances/tour/" + tourId + "?api_token=" + apiToken, function (result) {
					var tdata = result.data[0];
					if (!selectedTourDate) {

						selectedTourDate = convertBritishDateFormat(tdata.next_available_date);
					}
					var tourName = tdata.tour.name

					loadDates(tourId, selectedTourDate, tourDateInput, tdata);
					tourDateInput.off('change');
					tourDateInput.on('change', function () {
						var date = $(this).val();
						selectedTourDate = date;
						reloadTourInfo(tourId, selectedTourDate, selectedTourInstance, selectedTourPlaces, allowsU18, selectedTourPlacesU18);
					});

					jQuery.getJSON("https://" + url + "/api/v1/tourinstances/tour/" + tourId + "/date/" + convertNormalDateFormat(selectedTourDate) + "?api_token=" + apiToken, function (result) {
						jQuery('#tourDietaryRequirements__holder').hide();

						var html = '';
						if (Object.keys(result.data).length > 0) {
							
							let data_array = Object.values(result)[0];
							let price_structure = Object.values(data_array)[0].tour.price_structure;
							
							if ('label' in price_structure[0]) {
								var tr_label = price_structure[0]['label'];
								var tr_price = price_structure[0]['price'];
								var tr_id = price_structure[0]['id'];
								jQuery('#tour-place-label').html(tr_label+' (£'+tr_price+')');
								jQuery('#tour-place-label').attr('data-price',tr_price);
								jQuery('#tour-place-label').attr('data-price-id',tr_id);
							}
							
							
							jQuery.each(result['data'], function (i, field) {
								// if (tourInstance == field['tour_instance_id']) {
								// 	selected = ' selected="selected"';
								// } else {
								// 	selected = '';
								// }

								html += '<option value="' + field['tour_instance_id'] + '" data-time="' + field['tour_time'] + '" data-cost="' + field['tour']['price'] + '" data-capacity="' + field['remaining_places'] + '"' + selected + '>';
								html += field["tour_time"] + " (" + field['remaining_places'] + " places available)";
								html += '</option>';
								if (field['dietary_notes'] != null) {
									jQuery('#tourDietaryRequirements__holder').show();
									jQuery('#tourDietaryNotes').html(field['dietary_notes']);
								}
							});
						} else {
							html += '<option value="" data-capacity="0" selected>No available tours</option>';
						}
						$("#cboxLoadedContent #tourTimeSelect").html(html);
						// tourTimeSelect.html(html);

						selectedTourInstance = tourTimeSelect.children('option:selected').val();
						tourCost = jQuery('#tour-place-label').attr('data-price');
						selectedTourTime = tourTimeSelect.children('option:selected').data('time');


						var capacity = tourTimeSelect.children('option:selected').data('capacity');
						//tourtimeWORKS123

						if (tourPlaces > capacity) {
							selectedTourPlaces = 1;
						}
						if (capacity == '0') {
							tourPlacesSelect.html('<option value="" selected>No available tours</option>');
						} else {
							var html = '';
							for (var i = 1; i <= capacity; i++) {
								if (tourPlaces == i) {
									selected = ' selected="selected"';
								} else {
									selected = '';
								}
								html += '<option value="' + i + '"' + selected + '>' + i + '</option>';
							}
							tourPlacesSelect.html(html);
						}


						if (typeof tourPlaces === 'undefined' || tourPlaces == '') {
							selectedTourPlaces = tourPlacesSelect.children('option:first-child').val();
						}

						if (!isMobile) {
							jQuery.fn.colorbox.resize();	
						}

						tourTimeSelect.prop("readonly", false);
						tourPlacesSelect.prop("readonly", false);
					});
				});

			}
		}
		function loadDates(tourId, selectedTourDate, tourDateInput, tdata) {
			// Get unavailable dates for date picker

			selectedTourId = tourId;
			$.getJSON("https://" + url + "/api/v1/tour/" + tourId + "/unavailable?api_token=" + apiToken, function (result) {


				var dateStringToFormat = selectedTourDate + "T00:00:00Z";

				var correctedDate = new Date(dateStringToFormat);
				// Ensure timezone is correct to avoid timezones behind GMT showing previous day.
				var nextAvailableDate = new Date(correctedDate.valueOf() + correctedDate.getTimezoneOffset() * 60000);

				// If selected date is unavailable, move to next date
				while ($.inArray(selectedTourDate, result) != -1) {
					nextAvailableDate = new Date(selectedTourDate).fp_incr(1);
				}

				var dateTomorrow = new Date().fp_incr(1);
				// dateTomorrow = convertBritishDateFormat(dateTomorrow);

				// If next available date is today, make it tomorrow (don't support same day bookings)
				if (nextAvailableDate < dateTomorrow) {
					nextAvailableDate = dateTomorrow;
				}

				var doubleDigitMonth = ("0" + parseInt(nextAvailableDate.getMonth() + 1)).slice(-2);

				// Save default date
				selectedTourDate = nextAvailableDate.getDate() + "-" + doubleDigitMonth + "-" + nextAvailableDate.getFullYear();

				// Launch date picker
				var d = new Date();
				var year = d.getFullYear();
				var month = d.getMonth();
				var day = d.getDate();
				var dateNextYear = new Date(year + 1, month, day);

				//convert result to new date format
				var converted_result = [];
				for (let i = 0; i < result.length; i++) {
					var dateAr = result[i].split('-');
					var newDate = dateAr[2] + '-' + dateAr[1] + '-' + dateAr[0];
					converted_result.push(newDate);
				}

				datePicker = flatpickr("#cboxLoadedContent #tourDateInput", {
					inline: false,
					minDate: dateTomorrow,
					maxDate: dateNextYear,
					defaultDate: convertBritishDateFormat(nextAvailableDate), // Using nextAvailableDate instead of selectedTourDate for IE11 compat
					dateFormat: "d-m-Y",
					disable: converted_result,
					allowInput: true,
					disableMobile: true
				});


				// Remove duplicate date pickers
				if ($('#cboxLoadedContent .flatpickr-calendar').length > 1) {
					$('#cboxLoadedContent .flatpickr-calendar').last().remove();
				}

				$("#cboxLoadedContent #tourDateInput").val(convertBritishDateFormat(tdata.next_available_date));
				var date = $("#cboxLoadedContent #tourDateInput").val();
				selectedTourDate = date;

				// reloadDropdowns(tourId, selectedTourDate, selectedTourInstance, selectedTourPlaces, allowsU18, selectedTourPlacesU18, currindex);
			});
		}
		function getFirstIndex(array){
		    var result;
		    if(array instanceof Array){
		        for(var i in array){
		            result = i;
		            break;
		        }
		    } else {
		        return null;
		    }
		    return result;
		}
		function reloadTourInfo(tourId, selectedTourDate, selectedTourInstance, selectedTourPlaces, allowsU18, selectedTourPlacesU18) {
			var tourTimeSelect = jQuery('#tourTimeSelect');
			var tourPlacesSelect = jQuery('#tourPlacesSelect');

			tourTimeSelect.prop("readonly", true);
			tourPlacesSelect.prop("readonly", true);

			jQuery.getJSON("https://" + url + "/api/v1/tourinstances/tour/" + tourId + "/date/" + convertNormalDateFormat(selectedTourDate) + "?api_token=" + apiToken, function (result) {
				jQuery('#tourDietaryRequirements__holder').hide();

				var html = '';
				if (Object.keys(result.data).length > 0) {
					
					let data_array = Object.values(result)[0];
					let price_structure = Object.values(data_array)[0].tour.price_structure;
					
					if ('label' in price_structure[0]) {
						var tr_label = price_structure[0]['label'];
						var tr_price = price_structure[0]['price'];
						var tr_id = price_structure[0]['id'];
						jQuery('#tour-place-label').html(tr_label+' (£'+tr_price+')');
						jQuery('#tour-place-label').attr('data-price',tr_price);
						jQuery('#tour-place-label').attr('data-price-id',tr_id);
					}
					
					jQuery.each(result['data'], function (i, field) {
						// if (tourInstance == field['tour_instance_id']) {
						// 	selected = ' selected="selected"';
						// } else {
						// 	selected = '';
						// }

						html += '<option value="' + field['tour_instance_id'] + '" data-time="' + field['tour_time'] + '" data-cost="' + field['tour']['price'] + '" data-capacity="' + field['remaining_places'] + '"' + selected + '>';
						html += field["tour_time"] + " (" + field['remaining_places'] + " places available)";
						html += '</option>';
						if (field['dietary_notes'] != null) {
							jQuery('#tourDietaryRequirements__holder').show();
							jQuery('#tourDietaryNotes').html(field['dietary_notes']);
						}

					});
				} else {
					html += '<option value="" data-capcity="0" selected>No available tours</option>';
				}
				tourTimeSelect.html(html);
				selectedTourInstance = tourTimeSelect.children('option:selected').val();
				tourCost = jQuery('#tour-place-label').attr('data-price');
				selectedTourTime = tourTimeSelect.children('option:selected').data('time');


				var capacity = tourTimeSelect.children('option:selected').data('capacity');

				if (tourPlaces > capacity) {
					selectedTourPlaces = 1;
				}

				if (capacity == '0') {
					tourPlacesSelect.html('<option value="" selected>No available tours</option>');
				} else {
					var html = '';
					for (var i = 1; i <= capacity; i++) {
						if (tourPlaces == i) {
							selected = ' selected="selected"';
						} else {
							selected = '';
						}
						html += '<option value="' + i + '"' + selected + '>' + i + '</option>';
					}
					tourPlacesSelect.html(html);
				}

				if (typeof tourPlaces === 'undefined' || tourPlaces == '') {
					selectedTourPlaces = tourPlacesSelect.children('option:first-child').val();
				}


				if (!isMobile) {
					jQuery.fn.colorbox.resize();	
				}

				tourTimeSelect.prop("readonly", false);
				tourPlacesSelect.prop("readonly", false);
			});
		}

		function createBookingPopup() {
			var html = "";
			html += '<div class="tourDateBox tour-step1">';
			html += '<div class="section">';
			html += '<label class="box-label" for="tourSelect">Select a tour:</label>';
			html += '<div class="selectField">';
			html += '<select id="tourSelect" name="tourSelect">';
			html += '<!-- JS Populated -->';
			html += '</select>';
			html += '</div>';
			html += '</div>';
			html += '<div id="tourDate" class="section">';
			html += '<label class="box-label" for="tourDateInput">Select a date:</label>';
			html += '<div class="tour-date-input-holder"><input type="text" id="tourDateInput" name="date" readonly="readonly"></div>';
			html += '</div>';
			html += '<div id="tourTime" class="section">';
			html += '<label for="tourTimeSelect" class="box-label"> Select a tour time:</label>';
			html += '<div class="selectField">';
			html += '<select id="tourTimeSelect" name="time">';
			html += '<!-- JS Populated -->';
			html += '</select>';
			html += '</div>';
			html += '</div>';
			html += '<div id="tourPlaces" class="section">';
			html += '<label for="tourPlacesSelect" class="box-label"> Select number of tour places:</label> ';
			html += '<div class="selectField">';
			html += '<select id="tourPlacesSelect" class="with-label" name="places">';
			html += '<!-- JS Populated -->';
			html += '</select>';
			html += '<span id="tour-place-label"></span>';
			html += '</div>';
			html += '</div>';
			html += '<div class="proceed-tour book tour-payment tcm-cta" data-cta-action="Continue Booking to Personal Information" data-cta-event="ctaClicks" data-cta-label="Continue Booking">CONTINUE BOOKING</div>';
			html += "</div>";
			html += '<div class="tour-step3 hidden">';
			html += '<div id="payment-element"><!--Stripe.js injects the Payment Element--></div><button class="stripe-submit tcm-cta braze-btn-click" data-event-type="sdk_book_now_click" data-cta-action="Pay for tour" data-cta-event="ctaClicks" data-cta-label="Pay Now" type="button"><span class="button-text">Pay now</span></button><div class="hidden" id="payment-message">&nbsp;</div>';
			html += '</div>'
			$('#cboxLoadedContent').html(html);

			$.getJSON("https://" + url + "/api/v1/brand/1/tours?api_token=" + apiToken).done(function (result) {
				var html = "";
				html += "<option value=''>Select Tour</option>";
				jQuery.each(result.data, function (i, field) {
					html += '<option value="' + field['id'] + '" data-cost="' + field['price'] + '" data-capacity="' + field['capacity'] + '"' + selected + '>';
					html += field["name"];
					html += '</option>';
				});
				$("#cboxLoadedContent #tourSelect").html(html);
				if ($('.the-tour-name').length > 0) {
					
					// var tourpage = $('.the-tour-name').data('tourname');
					$("#cboxLoadedContent #tourSelect").find('option:selected').removeAttr('selected');
					var tourpageid = $('#tour-field-id').val();
					// if (tourpage == "Glenfiddich Distillery Tour") {
					// 	var selected_opt = $('#cboxLoadedContent #tourSelect option').filter(function () { return $(this).html() == "Glenfiddich Distillery Tour"; }).val();
					// } else {
					// 	var selected_opt = $('#cboxLoadedContent #tourSelect option').filter(function () { return $(this).html() == "Glenfiddich Solera: Deconstructed Tour"; }).val();
					// }
					$("#cboxLoadedContent #tourSelect option[value='"+tourpageid+"']").prop('selected', true);
					$("#cboxLoadedContent #tourSelect").trigger('change');
				}
			});

			$("#cboxLoadedContent #tourSelect").on('change', function () {
				loadTourTimesPlaces($(this).val());
			});
			
			$("#cboxLoadedContent #tourTimeSelect").on('change', function () {
				
				loadTourNumPlaces();
			});

			// 			var tdata = result.data[0];
			// 			if (!selectedTourDate) {
			// 	selectedTourDate = tdata.next_available_date;
			// }
			// var tourName = tdata.tour.name;



			// }
		}

		$(".buy_link, .buy_link a").on('click', function (e) {
			e.preventDefault();
		});
		var colorboxWidth = "90%";

		if (!isMobile) {
			colorboxWidth = "60%";
		}
		$('#paragraph__booking_navigation_item__3417, .book-tour-link, .book_now_btn, .book_btn_bottom, .buy_link, .buy_link a, .not-link').colorbox({
			inline: true,
			width: colorboxWidth,
			maxWidth: "100%",
			height: "380px",
			overlayClose: false,
			onOpen: function () {
				tourAllowsU18 = $(this).data('u18');
				loadedTourId = $(this).data('id');
				tourNameText = $(this).data('tourname');
				// $('html, body').animate({scrollTop : 0},500);
				$(".book-distillery-tour").css('overflow', 'hidden');
				// bookTour(currindex,loadedTourId);
			},
			onComplete: function () {
				// 			tourCost = $('#cboxLoadedContent #tourTimeSelect'+currindex).children('option:selected').data('cost');
				// 			selectedTourTime = $('#cboxLoadedContent #tourTimeSelect'+currindex).children('option:selected').data('time');
				// 			selectedTourInstance = $('#cboxLoadedContent #tourTimeSelect'+currindex).children('option:selected').val();

				createBookingPopup();
				if ($('.the-tour-name').length == 0) {
					$('#cboxOverlay').hide();
					$('.collection-whisky-listing.slick-initialized.slick-slider.slick-dotted').css('visibility', 'hidden');
					$('#colorbox').css('top', '30%');
				}


				var selectedTour = $("#cboxLoadedContent #tourSelect").children('option:selected').val();
				loadTourTimesPlaces(selectedTour);

				// if (selectedTour != null) {
				// 	loadTourTimePlaces();	
				// }
				// $.fn.colorbox.resize();
				if (!isMobile) {
					$.fn.colorbox.resize();
				}
			},
			onClosed: function () {
				var html = '<p id="loading">Please wait, tours reloading...</p>';
				$('#tourContainer1').html(html);
				$('#tourContainer2').html(html);
				$(".book-distillery-tour").css('overflow', 'visible');
				// $('html, body').animate({scrollTop : 0},500);
				// location.reload(true);
			}
		});

		$(document).on('click', '.tour-payment', function (e) {
			e.preventDefault();
			var tourSelect = $("#cboxLoadedContent #tourSelect option:selected").text();
			var tourDate = $("#cboxLoadedContent #tourDateInput").val();
			var tourTime = $("#cboxLoadedContent #tourTimeSelect option:selected").text();
			var tourPlace = $("#cboxLoadedContent #tourPlacesSelect option:selected").text();
			
			$('button.book.tour-payment').removeClass('with-error');
			if ($('#tourTime select').find(":selected").text() == 'No available tours') {
				$('.book.tour-payment').addClass('with-error');
			} else if ($("input[name='tourSelect']").val() == "" || $("input[name='date']").val() == "" || $("input[name='time']").val() == "" || $("input[name='places']").val()) {
				$('.book.tour-payment').addClass('with-error');
			} else {
				if ($(".tour-step2").length) {
					$(".tour-step1").hide();
					$(".tour-step2").removeClass("hidden");
					
					if (!isMobile) {
						$.fn.colorbox.resize();
					}
					// $.fn.colorbox.resize();
				} else {
					var container_id = $(this).closest('.more-info-lightbox').attr('id');
					tourPayment2(container_id);
				}
			}
		});


		// Hide menu toggle button clicked
		$(".toggle-arrow").css("opacity", "1");

		$(".toggle-link").on('click', function (e) {
			e.preventDefault();
			var parent = $(".booking-navigation-container");
			var arrow_width = 23;
			var left_offset = parent.width() - arrow_width;


			if (!$(this).hasClass('close') && !$(this).hasClass('open')) {
				$(this).addClass('close');
				parent.css("left", "-" + left_offset + "px");
			} else {
				if ($(this).hasClass('close')) {
					$(this).removeClass('close').addClass('open');
					parent.css("left", "0px");
				} else {
					$(this).removeClass('open').addClass('close');
					parent.css("left", "-" + left_offset + "px");
				}
			}



			return false
		});

		if (!$(".booking-navigation-container").hasClass("collapse")) {
			$(".toggle-link").removeClass('close');
		}

	}//if book-tour-distillery page

});//end doc ready
function loadTourNumPlaces()
{
	var tourTimeSelect = jQuery('#cboxLoadedContent #tourTimeSelect');
	var capacity = tourTimeSelect.children('option:selected').data('capacity');
	var tourPlacesSelect = jQuery('#cboxLoadedContent #tourPlacesSelect');

	var tourPlaces = 1;
	var html = '';
	for (var i = 1; i <= capacity; i++) {
		if (tourPlaces == i) {
			selected = ' selected="selected"';
		} else {
			selected = '';
		}
		html += '<option value="' + i + '"' + selected + '>' + i + '</option>';
	}
	tourPlacesSelect.html(html);
}
function bookTour(currindex, loadedTourId) {
	// Get global variables
	tourId = selectedTourId;
	allowsU18 = tourAllowsU18;
	tourDate = selectedTourDate;

	// Init element variables
	tourDateInput = $('#bookTourContainer' + tourId + '.more-info-lightbox #tourDateInput' + currindex + '');
	var tourTimeSelect = $('#bookTourContainer' + tourId + '.more-info-lightbox #tourTimeSelect' + currindex + '');
	var tourPlacesSelect = $('#bookTourContainer' + tourId + '.more-info-lightbox #tourPlacesSelect' + currindex + '');
	var tourPlacesU18Select = $('#bookTourContainer' + tourId + '.more-info-lightbox #tourPlacesU18Select');
	var tourName = $('.more-info-lightbox #tourName');

	// Page load initial date, time and places
	$.getJSON("https://" + url + "/api/v1/tourinstances/tour/" + tourId + "?api_token=" + apiToken, function (result) {

		if (!selectedTourDate) {
			selectedTourDate = result['data'][0]['next_available_date'];
		}

		// Get unavailable dates for date picker
		$.getJSON("https://" + url + "/api/v1/tour/" + tourId + "/unavailable?api_token=" + apiToken, function (result) {
			var dateStringToFormat = selectedTourDate + "T00:00:00Z";

			var correctedDate = new Date(dateStringToFormat);
			// Ensure timezone is correct to avoid timezones behind GMT showing previous day.
			var nextAvailableDate = new Date(correctedDate.valueOf() + correctedDate.getTimezoneOffset() * 60000);

			// If selected date is unavailable, move to next date
			while ($.inArray(selectedTourDate, result) != -1) {
				nextAvailableDate = new Date(selectedTourDate).fp_incr(1);
			}

			var dateTomorrow = new Date().fp_incr(1);

			// If next available date is today, make it tomorrow (don't support same day bookings)
			if (nextAvailableDate < dateTomorrow) {
				nextAvailableDate = dateTomorrow;
			}

			var doubleDigitMonth = ("0" + parseInt(nextAvailableDate.getMonth() + 1)).slice(-2);

			// Save default date
			selectedTourDate = nextAvailableDate.getDate() + "-" + doubleDigitMonth + "-" + nextAvailableDate.getFullYear();

			// Launch date picker
			var d = new Date();
			var year = d.getFullYear();
			var month = d.getMonth();
			var day = d.getDate();
			var dateNextYear = new Date(year + 1, month, day);
			if (currindex == 1) {
				datePicker = flatpickr("#cboxLoadedContent #tourDateInput1", {
					inline: false,
					minDate: convertBritishDateFormat(dateTomorrow),
					maxDate: dateNextYear,
					defaultDate: convertBritishDateFormat(nextAvailableDate), // Using nextAvailableDate instead of selectedTourDate for IE11 compat
					dateFormat: "d-m-Y",
					disable: result,
					allowInput: true,
					disableMobile: true
				});
			} else {

				datePicker = flatpickr("#cboxLoadedContent #tourDateInput2", {
					inline: false,
					minDate: convertBritishDateFormat(dateTomorrow),
					maxDate: dateNextYear,
					defaultDate: convertBritishDateFormat(nextAvailableDate), // Using nextAvailableDate instead of selectedTourDate for IE11 compat
					dateFormat: "d-m-Y",
					disable: result,
					allowInput: true,
					disableMobile: true
				});
			}

			// Remove duplicate date pickers
			if ($('#cboxLoadedContent .flatpickr-calendar').length > 1) {
				$('#cboxLoadedContent .flatpickr-calendar').last().remove();
			}

			$("#cboxLoadedContent #tourDateInput" + currindex).val();
			// var date = $("#cboxLoadedContent #tourDateInput"+currindex).val();
			// selectedTourDate = date;

			reloadDropdowns(tourId, selectedTourDate, selectedTourInstance, selectedTourPlaces, allowsU18, selectedTourPlacesU18, currindex);
		});
	});

	// When tour date changes
	tourDateInput.on('change', function () {
		var date = $(this).val();
		selectedTourDate = date;

		reloadDropdowns(tourId, selectedTourDate, selectedTourInstance, selectedTourPlaces, allowsU18, selectedTourPlacesU18, currindex);
	});

	// When time dropdown changes
	tourTimeSelect.on('change', function () {
		selectedTourInstance = $(this).children('option:selected').val();
		var capacity = $(this).children('option:selected').data('capacity');
		tourCost = $('#tour-place-label').attr('data-price');
		selectedTourTime = $(this).children('option:selected').data('time');
		$(this).children('option:selected').attr("selected", "selected");
		resetTourPlaces();
		loadTourPlaces();
		reloadDropdowns(tourId, selectedTourDate, selectedTourInstance, selectedTourPlaces, allowsU18, selectedTourPlacesU18, currindex);
	});

	// When places dropdown changes
	tourPlacesSelect.on('change', function () {
		selectedTourPlaces = $(this).children('option:selected').val();
		$(this).children('option:selected').attr("selected", "selected");

		if (selectedTourPlaces <= selectedTourPlacesU18) {
			selectedTourPlacesU18 = 0;
		}

		reloadDropdowns(tourId, selectedTourDate, selectedTourInstance, selectedTourPlaces, allowsU18, selectedTourPlacesU18, currindex);
	});

	// When U18 places dropdown changes
	tourPlacesU18Select.on('change', function () {
		selectedTourPlacesU18 = $(this).children('option:selected').val();
	});
}
function tourPayment(container_id) {

	// Get lightbox
	var lightbox = $('.more-info-lightbox');

	// Save old contents in case user wants to go back
	step1Content = $('#cboxLoadedContent').html();

	// Setup lightbox contents
	lightbox.html(payTourContainer.html());
	$('#' + container_id).find('.payment-element').attr('id', 'payment-element');

	lightbox.removeClass('bookTourContainer');
	lightbox.addClass('payTourContainer');

	// Resize lightbox after new contents
	setTimeout(function () {
		// $.fn.colorbox.resize();
		if (!isMobile) {
			$.fn.colorbox.resize();
		}
		// $('html, body').animate({scrollTop : 0},500);
	}, 300);

	// Init element variables
	var tourName = $('.more-info-lightbox #tourName');

	// Set tour name
	tourName.html(tourNameText);
	$('.tour-summary-title').html(tourNameText);
}
function tourPayment2(container_id) {
	$('#colorbox').css('top', '5% !important');

	// Get lightbox
	var lightbox = $('#cboxLoadedContent');
	var selected_country = $("#country_code").val();
	// Save old contents in case user wants to go back
	step1Content = $('#cboxLoadedContent').html();
	

	var payHTML = `<script src="https://cc-cdn.com/generic/scripts/v1/cc_c2a.min.js"></script>
		<form method="post" action="https://${url}/booking/createbookingV2" enctype="application/x-www-form-urlencoded" id="tourBookingForm">
			<input type="hidden" name="country_selected" id="country_selected" value="" />
        &nbsp;
      </form>
		<div class="more-info-lightbox payTourContainer tour-step2">
<h2>CONFIRM YOUR BOOKING</h2>

<p class="help-text">If you need help with your booking please call <a href="tel:+441340822211">+44 (0) 1340 822 211</a> or email <a href="mailto:glenfiddichbookings@wgrant.com">glenfiddich.bookings@wgrant.com</a></p>

<form class="desktop-container">
<div class="desktop-column first">
<h3>Enter your personal details:</h3>

<div class="section" id="tourContactFName"><label class="req" for="tourContactFNameInput">First name:</label>

<div class="textField"><input id="tourContactFNameInput" name="fname" required="" type="text" value="" /></div>
</div>

<div class="section" id="tourContactLName"><label class="req" for="tourContactLNameInput">Last name:</label>

<div class="textField"><input id="tourContactLNameInput" name="lname" required="" type="text" value="" /></div>
</div>

<div class="section" id="tourContactEmail"><label class="req" for="tourContactEmailInput">Email address:</label>

<div class="textField"><input id="tourContactEmailInput" name="email" pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}" required="" type="email" value="" /></div>
</div>

<div class="section" id="tourContactTelephone"><label class="req" for="tourContactTelephoneInput">Telephone number:</label>

<div class="textField"><input id="tourContactTelephoneInput" name="telephone" required="" type="tel" value="" /></div>
<span class="desc">In case we need to contact you about your tour booking.</span></div>

<div class="section" id="tourContactTelephone"><label class="req" for="tourContactTelephoneInput">Date of Birth:</label>
<div class="textField"><input id="tourContactDOB" name="date_of_birth" required="" value="" /></div>
</div>

<div class="section" id="tourDietaryRequirements__holder"><label for="tourDietaryRequirements">Dietary requirements:</label>

<div class="textField"><input id="tourDietaryRequirements" name="tourDietaryRequirements" type="text" value="" /></div>
</div>

<h3>Your billing address:</h3>
<span class="desc">For security reasons this needs to match your payment card details</span>

<div class="section" id="tourSearchAddress"><label for="tourSearchAddressInput">Search for your address:</label>

<div class="textField"><input autocomplete="new-street-address" id="tourSearchAddressInput" name="searchaddress" type="text" value="" /></div>
</div>

<p id="tourPrintAddress">&nbsp;</p>

<p><a href="#" id="tourAddressManually">Can't find your address? Click here to enter manually.</a></p>

<div id="tourFullAddress" style="display: none;">
<div class="section" id="tourAddress1"><label for="tourAddress1Input">Address Line 1:</label>

<div class="textField"><input class="addressField" id="tourAddress1Input" name="addressline1" required="" type="text" value="" /></div>
</div>

<div class="section" id="tourAddress2"><label for="tourAddress2Input">Address Line 2:</label>

<div class="textField"><input class="addressField" id="tourAddress2Input" name="addressline2" type="text" value="" /></div>
</div>

<div class="section" id="tourCity"><label for="tourCityInput">City:</label>

<div class="textField"><input class="addressField" id="tourCityInput" name="city" required="" type="text" value="" /></div>
</div>

<div class="section" id="tourCounty"><label for="tourCountyInput">County / State:</label>

<div class="textField"><input class="addressField" id="tourCountyInput" name="county" required="" type="text" value="" /></div>
</div>

<div class="section" id="tourPostcode"><label for="tourPostcodeInput">Postcode:</label>

<div class="textField"><input class="addressField" id="tourPostcodeInput" name="postcode" required="" type="text" value="" /></div>
</div>

<div class="section" id="tourCountry"><label for="tourCountrySelect">Country:</label>

<div class="selectField"><select class="addressField" id="tourCountrySelect" name="country" required=""><option value="">Please Select</option><option value="GB">United Kingdom</option><option value="">-</option><option value="AF">Afghanistan</option><option value="AX">Åland Islands</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia, Plurinational State of</option><option value="BQ">Bonaire, Sint Eustatius and Saba</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="BN">Brunei Darussalam</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="CV">Cape Verde</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo</option><option value="CD">Congo, the Democratic Republic of the</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="CI">Côte d'Ivoire</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands (Malvinas)</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="VA">Holy See (Vatican City State)</option><option value="HN">Honduras</option><option value="HK">Hong Kong</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran, Islamic Republic of</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KP">Korea, Democratic People's Republic of</option><option value="KR">Korea, Republic of</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Lao People's Democratic Republic</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao</option><option value="MK">Macedonia, the former Yugoslav Republic of</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia, Federated States of</option><option value="MD">Moldova, Republic of</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory, Occupied</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RE">Réunion</option><option value="RO">Romania</option><option value="RU">Russian Federation</option><option value="RW">Rwanda</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena, Ascension and Tristan da Cunha</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin (French part)</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten (Dutch part)</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syrian Arab Republic</option><option value="TW">Taiwan</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania, United Republic of</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VE">Venezuela, Bolivarian Republic of</option><option value="VN">Viet Nam</option><option value="VG">Virgin Islands, British</option><option value="VI">Virgin Islands, U.S.</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option> </select></div>
</div>
</div>

<div class="metrics-border-box">
${(selected_country == 'en-gb' || selected_country == 'en-us') ? 
'<div class="text-field" style="text-align: left;"><label class="help-text" for="terms" style="display: inline-block;"><input id="terms" name="terms" style="display: inline-block;" type="checkbox" value="1"/> I confirm that I agree to the <a href="https://www.glenfiddich.com/en-gb/tours-terms-and-conditons" target="_blank">Tours Terms and Conditions</a>. For information about how William Grant & Sons will use your information please read our <a href="https://www.glenfiddich.com/' + selected_country + '/privacy-policy/" target="_blank">Privacy Policy</a>. By ticking here you also confirm that you have read the <a href="https://www.glenfiddich.com/' + selected_country +  '/privacy-policy/" target="_blank">privacy policy</a>.</label></div><div class="text-field" style="text-align: left;"><label class="help-text" for="consent_guest" style="display: inline-block;"><input id="consent_guest" name="consent_guest" style="display: inline-block;" type="checkbox" value="1" /> I CONFIRM THAT ALL GUESTS INCLUDED IN THIS BOOKING ARE OVER THE LEGAL PURCHASE AGE ON THE DATE OF THE VISIT.</label></div><div class="text-field" style="text-align: left;"><label class="help-text" for="consent" style="display: inline-block;"><input id="consent" name="consent" style="display: inline-block;" type="checkbox" value="1" /> By clicking on "sign me up", I consent to the William Grant & Sons Group\'s use of my data in order to receive news and offers from Glenfiddich by email, and the use of web tags and analytics to measure my interaction with these communications. *<br/><br/>Opt-out at any time by using the unsubscription mechanism provided in relevant communications</label></div>' 
: '<div class="text-field" style="text-align: left;"><label class="help-text" for="terms" style="display: inline-block;"><input id="terms" name="terms" style="display: inline-block;" type="checkbox" value="1"/> I confirm that I agree to the <a href="https://www.glenfiddich.com/en-gb/tours-terms-and-conditons" target="_blank">Tours Terms and Conditions</a>. For information about how William Grant & Sons will use your information please read our <a href="https://www.glenfiddich.com/' + (selected_country != undefined ? selected_country + "/" : "" ) +  'privacy-policy/" target="_blank">Privacy Policy</a>. By ticking here you also confirm that you have read the <a href="https://www.glenfiddich.com/' + (selected_country != undefined ? selected_country + "/" : "" ) + 'privacy-policy/" target="_blank">privacy policy</a>.</label></div><div class="text-field" style="text-align: left;"><label class="help-text" for="consent_guest" style="display: inline-block;"><input id="consent_guest" name="consent_guest" style="display: inline-block;" type="checkbox" value="1" /> I CONFIRM THAT ALL GUESTS INCLUDED IN THIS BOOKING ARE OVER THE LEGAL PURCHASE AGE ON THE DATE OF THE VISIT.</label></div><div class="text-field" style="text-align: left;"><label class="help-text" for="consent" style="display: inline-block;"><input id="consent" name="consent" style="display: inline-block;" type="checkbox" value="1" /> By clicking on "sign me up", I consent to the William Grant & Sons Group\'s use of my data in order to receive news and offers from Glenfiddich by email, and the use of web tags and analytics to measure my interaction with these communications. *<br/><br/>Opt-out at any time by using the unsubscription mechanism provided in relevant communications</label></div>'}
</div>
<button class="book confirm-booking mobile-only tcm-cta" data-cta-action="Proceed to tour payment form" data-cta-event="ctaClicks" data-cta-label="Proceed to Payment">Proceed to Payment</button></div>

<div class="desktop-column second">

<div class="proceed-holder"><button class="book confirm-booking proceed-right tcm-cta" data-cta-action="Proceed to tour payment form" data-cta-event="ctaClicks" data-cta-label="Proceed to Payment">Proceed to Payment</button></div>
<div class="spinner hidden" id="spinner">&nbsp;</div>

</div>
</form>
</div>
`;



	// Setup lightbox contents
	$('#cboxLoadedContent .tour-step1').hide();
	$('#cboxLoadedContent').append(payHTML);

	// $('#'+container_id).find('.payment-element').attr('id','payment-element');

	lightbox.removeClass('bookTourContainer');
	lightbox.addClass('payTourContainer');

	// if (current_country == "en-gb") {
	// 	flatpickr("#cboxLoadedContent #tourContactDOB", {
	// 		inline: false,
	// 		dateFormat: "d/m/Y",
	// 		allowInput: true,
	// 		maxDate: "today"
	// 	});
	// } else {
	// 	flatpickr("#cboxLoadedContent #tourContactDOB", {
	// 		inline: false,
	// 		dateFormat: "m/d/Y",
	// 		allowInput: true,
	// 		maxDate: "today"
	// 	});
	// }

	flatpickr("#cboxLoadedContent #tourContactDOB", {
		inline: false,
		dateFormat: "d/m/Y",
		allowInput: true,
		maxDate: "today"
	});

	// Resize lightbox after new contents
	setTimeout(function () {
		// $.fn.colorbox.resize();
		if (!isMobile) {
			$.fn.colorbox.resize();
		}
		// $('html, body').animate({scrollTop : 0},500);


	}, 300);

	// Init element variables
	var tourName = $('#tourSelect').children('option:selected').text();

	// Set tour name
	// tourName.html(tourNameText);
	$('.tour-summary-title').html(tourNameText);
	
	new clickToAddress({
		accessToken: '45c34-b9f5b-4975e-027e6', // Replace this with your access token
		dom: {
			search: $('#cboxLoadedContent #tourSearchAddressInput')[0],
			line_1: $('#cboxLoadedContent #tourAddress1Input')[0],
			line_2: $('#cboxLoadedContent #tourAddress2Input')[0],
			town: $('#cboxLoadedContent #tourCityInput')[0],
			postcode: $('#cboxLoadedContent #tourPostcodeInput')[0],
			county: $('#cboxLoadedContent #tourCountyInput')[0],
			country: $('#cboxLoadedContent #tourCountrySelect')[0]
		},
		domMode: 'object',
		historyTools: false,
		disableAutoSearch: false,
		onResultSelected: function (c2a, elements, address) {

			// Create string of selected address
			var printAddress = "";
			printAddress += address['line_1'] != "" ? address['line_1'] + ", " : "";
			printAddress += address['line_2'] != "" ? address['line_2'] + ", " : "";
			printAddress += address['line_3'] != "" ? address['line_3'] + ", " : "";
			printAddress += address['line_4'] != "" ? address['line_4'] + ", " : "";
			printAddress += address['locality'] != "" ? address['locality'] + ", " : "";
			printAddress += address['province_name'] != "" ? address['province_name'] + ", " : "";
			printAddress += address['postal_code'] != "" ? address['postal_code'] + ", " : "";
			printAddress += address['country_name'] != "" ? address['country_name'] : "";

			// Print selected address
			$('#cboxLoadedContent #tourPrintAddress').html("<strong>Selected Billing Address:</strong><br/>" + printAddress);

			// Save selected address into input box
			$('#cboxLoadedContent #tourSearchAddressInput').val(printAddress);

			// Save form data once address selected
			formData['addressline1'] = $("#cboxLoadedContent #tourAddress1Input").val() != "" ? $("#cboxLoadedContent #tourAddress1Input").val() : "";
			formData['addressline2'] = $("#cboxLoadedContent #tourAddress2Input").val() != "" ? $("#cboxLoadedContent #tourAddress2Input").val() : "";
			formData['city'] = $("#cboxLoadedContent #tourCityInput").val() != "" ? $("#cboxLoadedContent #tourCityInput").val() : "";
			formData['county'] = $("#cboxLoadedContent #tourCountyInput").val() != "" ? $("#cboxLoadedContent #tourCountyInput").val() : "";
			formData['postcode'] = $("#cboxLoadedContent #tourPostcodeInput").val() != "" ? $("#cboxLoadedContent #tourPostcodeInput").val() : "";
			formData['country'] = $("#cboxLoadedContent #tourCountrySelect").val() != "" ? $("#cboxLoadedContent #tourCountrySelect").val() : "";


			if ($("#cboxLoadedContent #tourCountrySelect").val() == "GB") {
				$('#cboxLoadedContent #alchemetrics-checkbox').removeClass('hidden');
			} else {
				$('#cboxLoadedContent #alchemetrics-checkbox').addClass('hidden');
			}

			// Remove validation errors
			$('.error-message').remove();
			$('.addressField').removeClass('error');

			// Resize lightbox with new data
			// if (!isMobile) {
				$.fn.colorbox.resize();
			// }
		}
	});
	

	// Click on manually enter address
	$('#cboxLoadedContent #tourAddressManually').on('click', function (e) {
		e.preventDefault();
		// Show manual address fields
		$('#cboxLoadedContent #tourFullAddress').show();

		// Resize lightbox after new contents
		setTimeout(function () {
			// $.fn.colorbox.resize();
			// $('html, body').animate({ scrollTop : $('#cboxLoadedContent #tourFullAddress').offset().top - 100 },500);
		}, 300);
	});


	// Save form data as its entered
	$('input, select').on('change', function () {
		var fieldName = $(this).attr('name');
		formData[fieldName] = $(this).val() != "" ? $(this).val() : "";
		$('.error-message').remove();
		$(this).removeClass('error');
	});

	// Show cost of tour
	var selectedTourPlaces = $('#tourPlacesSelect').val();

	var tourCost = jQuery('#tour-place-label').attr('data-price');
	$('.more-info-lightbox #cost').html('£' + parseFloat(tourCost * (selectedTourPlaces - selectedTourPlacesU18)).toFixed(2));
	$('.more-info-lightbox #qty').html('x ' + selectedTourPlaces);

	if (tourAllowsU18 == 1) {
		$('.more-info-lightbox #u18qty').html(selectedTourPlacesU18);
	} else {
		$('.more-info-lightbox #u18qty').hide();
		$('.more-info-lightbox .total-pad').attr('colspan', 2);
	}
	$('.more-info-lightbox #tour').html(tourNameText);
	$('.more-info-lightbox #price').html('£' + tourCost);

	var selectedTourDate = $('#tourDateInput').val();

	var dateStringToFormat = convertNormalDateFormat(selectedTourDate);
	var formatDate = new Date(dateStringToFormat);


	// Ensure timezone is correct to avoid timezones behind GMT showing previous day.
	formatDate = new Date(formatDate.valueOf() + formatDate.getTimezoneOffset() * 60000);

	$('.more-info-lightbox #date').html(formatDate.getDate() + "/" + parseInt(formatDate.getMonth() + 1) + "/" + formatDate.getFullYear());
	$('.more-info-lightbox #time').html(selectedTourTime);

	// Go back to previous step
	$(document).on('click', '.go-back', function (e) {
		e.preventDefault();
		$(".tour-step3").addClass("hidden");
		$(".tour-step1").show();
		if (!isMobile) {
			$.fn.colorbox.resize();
		}
		// $('#cc_c2a').remove();
		// $('#cboxLoadedContent').html(step1Content);
		// lightbox.addClass('bookTourContainer');
		// lightbox.removeClass('payTourContainer');
		// bookTour();
		// $('html, body').animate({scrollTop : 0},500);
	});

	$('.confirm-booking').on('click', function (e) {
		e.preventDefault();

		// Validation
		if ($('#cboxLoadedContent  #terms').prop("checked")) {
			// it is checked
		} else {
			validation_message('Please confirm that you agree to the tours terms & conditions.', 'terms');
		}
		
		if ($('#cboxLoadedContent  #consent_guest').prop("checked")) {
			// it is checked
		} else {
			validation_message('Please confirm that all guests included in this booking are over the legal purchasing age on the date of the visit.', 'consent_guest');
		}

		if ($('#cboxLoadedContent  #consent').prop("checked")) {
			// it is checked
			sessionStorage.setItem("marketing_consent", "yes");
		} else {
			sessionStorage.setItem("marketing_consent", "no");
		}

		if ($(".payTourContainer #tourContactDOB").val() == '') {
			validation_message('Please enter your date of birth', 'date_of_birth');
		}
		if ($(".payTourContainer input[name=fname]").val() == '') {
			validation_message('Please enter your first name', 'fname');
		}

		if ($(".payTourContainer input[name=lname]").val() == '') {
			validation_message('Please enter your last name', 'lname');
		}
		
		if ($(".payTourContainer input[name=searchaddress]").val() == '') {
			validation_message('Please enter your address', 'searchaddress');
		}

		if ($(".payTourContainer input[name=email]").val() == '') {
			validation_message('Please enter your email address', 'email');
		} else if (!isValidEmailAddress($("input[name=email]").val())) {
			validation_message('Please enter a valid email address', 'email');
		}

		if ($(".payTourContainer input[name=telephone]").val() == '') {
			validation_message('Please enter your telephone number', 'telephone');
		} else if (!isValidTelephone($("input[name=telephone]").val())) {
			validation_message('Please enter a valid telephone number', 'telephone');
		}

		if ($(".payTourContainer input[name=addressline1]").val() == '') {
			validation_message('Please enter your billing address or search for your address above', 'addressline1', true);
		}

		if ($(".payTourContainer input[name=city]").val() == '') {
			validation_message('Please enter your city', 'city', true);
		}

		if ($(".payTourContainer input[name=county]").val() == '') {
			validation_message('Please enter your county or state', 'county', true);
		}

		if ($(".payTourContainer input[name=postcode]").val() == '') {
			validation_message('Please enter your postcode', 'postcode', true);
		}

		if ($(".payTourContainer input[name=country]").val() == '') {
			validation_message('Please select your location', 'country', true);
		}

		run_validation();
	});

}
function colorboxInit(currindex) {
	$('.more-info-click' + currindex).colorbox({
		inline: true,
		width: "100%",
		maxWidth: "100%",
		height: "120%",
		overlayClose: false,
		onOpen: function () {
			tourAllowsU18 = $(this).data('u18');
			loadedTourId = $(this).data('id');
			tourNameText = $(this).data('tourname');
			// $('html, body').animate({scrollTop : 0},500);

			bookTour(currindex, loadedTourId);
		},
		onComplete: function () {
			tourCost = jQuery('#tour-place-label').attr('data-price');
			selectedTourTime = $('#cboxLoadedContent #tourTimeSelect' + currindex).children('option:selected').data('time');
			selectedTourInstance = $('#cboxLoadedContent #tourTimeSelect' + currindex).children('option:selected').val();
			$.fn.colorbox.resize();
		},
		onClosed: function () {
			var html = '<p id="loading">Please wait, tours reloading...</p>';
			$('#tourContainer1').html(html);
			$('#tourContainer2').html(html);
			// $('html, body').animate({scrollTop : 0},500);
			// location.reload(true);
		}
	});

}

function sortJsonOrder(a, b) {
	return a.sort_order > b.sort_order ? 1 : -1;
}

function reloadDropdowns(tourId, date, tourInstance, tourPlaces, allowsU18, tourPlacesU18, currindex) {


	tourTimeSelect = jQuery('#bookTourContainer' + tourId + '.more-info-lightbox #tourTimeSelect' + currindex);
	tourPlacesSelect = jQuery('#bookTourContainer' + tourId + '.more-info-lightbox #tourPlacesSelect' + currindex);
	var tourPlacesU18Container = jQuery('.more-info-lightbox #tourPlacesU18');
	var tourPlacesU18Select = jQuery('#bookTourContainer' + tourId + '.more-info-lightbox #tourPlacesU18Select');

	tourTimeSelect.prop("readonly", true);
	tourPlacesSelect.prop("readonly", true);
	tourPlacesU18Select.prop("readonly", true);

	jQuery.getJSON("https://" + url + "/api/v1/tourinstances/tour/" + tourId + "/date/" + convertNormalDateFormat(date) + "?api_token=" + apiToken, function (result) {
		jQuery('#tourDietaryRequirements__holder').hide();

		var html = '';
		if (Object.keys(result.data).length > 0) {
			
			let data_array = Object.values(result)[0];
			let price_structure = Object.values(data_array)[0].tour.price_structure;
			
			if ('label' in price_structure[0]) {
				var tr_label = price_structure[0]['label'];
				var tr_price = price_structure[0]['price'];
				var tr_id = price_structure[0]['id'];
				jQuery('#tour-place-label').html(tr_label+' (£'+tr_price+')');
				jQuery('#tour-place-label').attr('data-price',tr_price);
				jQuery('#tour-place-label').attr('data-price-id',tr_id);
			}
			
			jQuery.each(result['data'], function (i, field) {

				if (tourInstance == field['tour_instance_id']) {
					selected = ' selected="selected"';
				} else {
					selected = '';
				}

				html += '<option value="' + field['tour_instance_id'] + '" data-time="' + field['tour_time'] + '" data-cost="' + field['tour']['price'] + '" data-capacity="' + field['remaining_places'] + '"' + selected + '>';
				html += field["tour_time"] + " (" + field['remaining_places'] + " places available)";
				html += '</option>';
				if (field['dietary_notes'] != null) {
					jQuery('#tourDietaryRequirements__holder').show();
					jQuery('#tourDietaryNotes').html(field['dietary_notes']);
				}

			});
		} else {
			html += '<option value="" selected>No available tours</option>';
		}
		tourTimeSelect.html(html);

		selectedTourInstance = tourTimeSelect.children('option:selected').val();
		tourCost = jQuery('#tour-place-label').attr('data-price');
		selectedTourTime = tourTimeSelect.children('option:selected').data('time');


		var capacity = tourTimeSelect.children('option:selected').data('capacity');

		if (tourPlaces > capacity) {
			selectedTourPlaces = 1;
		}

		var html = '';
		for (var i = 1; i <= capacity; i++) {
			if (tourPlaces == i) {
				selected = ' selected="selected"';
			} else {
				selected = '';
			}
			html += '<option value="' + i + '"' + selected + '>' + i + '</option>';
		}
		tourPlacesSelect.html(html);

		if (typeof tourPlaces === 'undefined' || tourPlaces == '') {
			selectedTourPlaces = tourPlacesSelect.children('option:first-child').val();
		}

		if (allowsU18 == 1) {
			if (!tourPlaces) {
				tourPlaces = 1;
			}

			var html = '<option value="0">0</option>';
			for (var i = 1; i <= tourPlaces - 1; i++) {
				if (tourPlacesU18 == i) {
					selected = ' selected="selected"';
				} else {
					selected = '';
				}
				html += '<option value="' + i + '"' + selected + '>' + i + '</option>';
			}
			tourPlacesU18Select.html(html);
			tourPlacesU18Container.show();
		}

		if (!isMobile) {
			$.fn.colorbox.resize();
		}

		tourTimeSelect.prop("readonly", false);
		tourPlacesSelect.prop("readonly", false);
		tourPlacesU18Select.prop("readonly", false);
	});
}
function validation_message(text, fieldname, expandAddress) {
	expandAddress = expandAddress || false;

	validationMessages.push(new Array(fieldname, text, expandAddress));
}
function run_validation() {
	jQuery('.error-message').remove();

	for (var i = 0; i < validationMessages.length; i++) {

		if (validationMessages[i][2]) {
			jQuery('#cboxLoadedContent #tourFullAddress').show();
			jQuery.fn.colorbox.resize();
		}

		var elem = jQuery('#cboxLoadedContent *[name=' + validationMessages[i][0] + ']');
		var html = "<div class='error-message'>" + validationMessages[i][1] + "</div>";
		elem.addClass('error');
		elem.parent().parent().append(html);

		if (i == 0) {
			elem.focus();
			jQuery('html, body').animate({ scrollTop: elem.offset().top - 300 }, 500);
		}
	}

	if (validationMessages.length > 0) {
		validationMessages = [];
		return false;
	}

	// Store data before clear page
	// var submitData = {
	// 	'tour_instance_id': selectedTourInstance,
	// 	'tour_ticket_price': jQuery('.more-info-lightbox #cost').html().replace('£',''),
	// 	'booking_date': selectedTourDate,
	// 	'quantity': selectedTourPlaces,
	// 	'first_name': formData['fname'],
	// 	'last_name': formData['lname'],
	// 	'email_address': formData['email'],
	// 	'telephone_num': formData['telephone'],
	// 	'billing_address_line_1': formData['addressline1'],
	// 	'billing_address_line_2': formData['addressline2'],
	// 	'billing_city': formData['city'],
	// 	'billing_state_province': formData['county'],
	// 	'billing_postcode': formData['postcode'],
	// 	'billing_country': formData['country'],
	// 	'marketing_consent': sessionStorage.getItem("marketing_consent"),
	// 	'return_path': '$AbsoluteLink',
	// 	'tourDietaryRequirements': formData['tourDietaryRequirements']
	// };

	// if (tourAllowsU18 == 1) {
	// 	submitData['qty_u18'] = selectedTourPlacesU18;
	// }

	// if (jQuery(window).width() <= 768) {
	// 	submitData['mobile_mode'] = true;
	// }

	var name = jQuery('span#tour').text();

	if (typeof ga !== 'undefined') {
	  ga.getAll()[0].send({
		hitType: 'event',
		eventCategory: 'Tour Booking',
		eventAction: 'Click Proceed To Payment',
		eventLabel: 'Go to payment'
	  });

	  ga.getAll()[0].send({
		hitType: 'pageview',
		page: 'book-tour/payment-details'
	  });
    }

	// Setup lightbox contents
	var lightbox = jQuery('.more-info-lightbox');
	lightbox.html(submitContainer.html());
	lightbox.addClass('submitContainer');

	setTimeout(function () {
		// jQuery.fn.colorbox.resize();
		// jQuery('html, body').animate({scrollTop : 0},500);
	}, 300);

	if ($("#booking-summary").length) {
		$(".tour-step2").addClass('hidden');
		$(".tour-step3").removeClass('hidden');

		selectedTourPlaces = $('#tourPlacesSelect').val();
		selectedTourInstance = jQuery('#cboxLoadedContent #tourTimeSelect').children('option:selected').val();
		tourCost = jQuery('#tour-place-label').attr('data-price');
		selectedTourTime = jQuery('#cboxLoadedContent #tourTimeSelect').children('option:selected').data('time');
		selectedTourDate = jQuery('#cboxLoadedContent #tourDateInput').val();
		var tourCost = jQuery('#tour-place-label').attr('data-price');
		var totalcost_final = parseFloat(tourCost * selectedTourPlaces).toFixed(2);
		// Show cost of tour
		$('#booking-summary #cost').html('£' + totalcost_final);

		$('#booking-summary #qty').html('x ' + selectedTourPlaces);
		$('#booking-summary #tour').html(jQuery("#cboxLoadedContent #tourSelect option:selected").text());
		$('#booking-summary #price').html('£' + tourCost);
		var dateStringToFormat = convertNormalDateFormat(selectedTourDate) + "T00:00:00Z";

		var formatDate = new Date(dateStringToFormat);
		// alert(convertNormalDateFormat(formatDate));
		// Ensure timezone is correct to avoid timezones behind GMT showing previous day.
		formatDate = new Date(formatDate.valueOf() + formatDate.getTimezoneOffset() * 60000);

		$('#booking-summary #date').html(formatDate.getDate() + "/" + parseInt(formatDate.getMonth() + 1) + "/" + formatDate.getFullYear());
		$('#booking-summary #time').html(selectedTourTime);

	} else {

		var bookingsummary = `<table id="booking-summary">
		<tbody>
			<tr>
				<th colspan="5">
				<h2>YOUR ORDER SUMMARY</h2>
				</th>
			</tr>
			<tr>
				<td class="tour-thumbnail" colspan="2"><img alt="glenfiddich tour" data-entity-type="file" data-entity-uuid="b8f9fdb8-3d23-4868-a90f-59cc3c1b4fd2" src="/sites/default/files/inline-images/tour1.jpeg" /></td>
				<td class="tour-info-text" colspan="3"><span id="qty">x {qty}</span> <span id="u18qty">{u18_qty}</span>
				<div class="tour-summary-title" id="tour">Glenfiddich Solera:<br />
				Deconstructed Tour</div>
				<span id="date">{date}</span> <span class="atc">at</span> <span id="time">{time}</span>
				<div><span id="price">£{price}</span></div>
				</td>
			</tr>
			<tr>
				<td class="change-booking" colspan="3">
				<p><a class="go-back" href="#">Change Booking</a></p>
				</td>
				<td class="no-border total-td">Total:</td>
				<td class="no-border total"><span id="cost">£{cost}</span></td>
			</tr>
			<tr>
				<td class="proceed-pay-td" colspan="5"><button class="book confirm-booking proceed-right">Proceed to Payment</button></td>
			</tr>
		</tbody>
	</table>`;

		selectedTourPlaces = $('#tourPlacesSelect').val();
		selectedTourInstance = jQuery('#cboxLoadedContent #tourTimeSelect').children('option:selected').val();
		tourCost = jQuery('#tour-place-label').attr('data-price');
		selectedTourTime = jQuery('#cboxLoadedContent #tourTimeSelect').children('option:selected').data('time');
		selectedTourDate = jQuery('#cboxLoadedContent #tourDateInput').val();

		$('.tour-step2').addClass('hidden');
		$('.tour-step3').prepend(bookingsummary);
		$('.tour-step3').removeClass('hidden');
		$('#cboxLoadedContent').append('<div class="clearfix"></div>');
		var tourCost = jQuery('#tour-place-label').attr('data-price');
		var totalcost_final = parseFloat(tourCost * selectedTourPlaces).toFixed(2);
		// Show cost of tour
		$('#booking-summary #cost').html('£' + totalcost_final);

		$('#booking-summary #qty').html('x ' + selectedTourPlaces);

		if (tourAllowsU18 == 1) {
			$('#booking-summary #u18qty').html(selectedTourPlacesU18);
		} else {
			$('#booking-summary #u18qty').hide();
			$('#booking-summary .total-pad').attr('colspan', 2);
		}

		$('#booking-summary #tour').html(jQuery("#cboxLoadedContent #tourSelect option:selected").text());
		$('#booking-summary #price').html('£' + tourCost);


		var dateStringToFormat = (convertNormalDateFormat(selectedTourDate));

		var formatDate = new Date(dateStringToFormat);
		// Ensure timezone is correct to avoid timezones behind GMT showing previous day.
		formatDate = new Date(formatDate.valueOf() + formatDate.getTimezoneOffset() * 60000);

		$('#booking-summary #date').html(formatDate.getDate() + "/" + parseInt(formatDate.getMonth() + 1) + "/" + formatDate.getFullYear());
		$('#booking-summary #time').html(selectedTourTime);

		// Go back to previous step
		$(document).on('click', '.go-back', function (e) {
			e.preventDefault();
			// $('#cc_c2a').remove();
			// $('#cboxLoadedContent').html(step1Content);
			// lightbox.addClass('bookTourContainer');
			// lightbox.removeClass('payTourContainer');
			// bookTour();
			// $('html, body').animate({scrollTop : 0},500);
		});



		formData = processBooking();
		initializeStripe(formData);
		$('.proceed-pay-td').hide();
	}
}

var stripe = "";

if ($('#stripe-public-key').length) {
	stripe = Stripe($('#stripe-public-key').val());
}
let elements;
checkStatus();
function initializeStripe(formData) {
	$.ajax({
		url: "https://" + url + "/booking/createbookingStripe",
		type: "post",
		// dataType: 'jsonp',
		data: formData,
		success: function (response) {
			var secretData = JSON.parse(response);
			$('.stripe-submit').data('bookingId', secretData.bookingId);
			$('.stripe-submit').data('paymentId', secretData.bookingId);
			$('.stripe-submit').data('gfBookingId', secretData.gfBookingId);
			const appearance = {
				theme: 'stripe',

				rules: {
					'.Label': {
						textTransform: 'uppercase',
						fontSize: '12px',
						paddingBottom: '5px',
						colorText: '#ffffff',
						color: '#ffffff',
						borderColor: '#000000',
					},
					'.PickerItem': {
						colorText: '#000000',
					}
				},
				variables: {
					// colorPrimary: '#0570de',
					// colorBackground: '#000000',
					colorDanger: '#df1b41',
					fontFamily: 'system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji',
					// See all possible variables below
				}
			};
			secretData.appearance = appearance;

			elements = stripe.elements({
			  clientSecret: secretData.clientSecret,
			  bookingId: secretData.bookingId, 
			  gfBookingId: secretData.gfBookingId,
			  paymentId: secretData.paymentId
			});
			
			const paymentElement = elements.create('payment', {});
			paymentElement.mount("#payment-element");
			$('.stripe-submit').show();
		},
		error: function (jqXHR, textStatus, errorThrown) {
		}
	});
}
// async function initializeStripe(formData) {
//   const { clientSecret } = await fetch("https://tours.testapp/booking/createPaymentIntent", {
//     method: "POST",
//     body: data1
//   });

// }
$(document).on('click', '.stripe-submit', function () {
	var dataBookingId = $(this).data('bookingId');
	var dataPaymentId = $(this).data('paymentId');
	var dataGFBookingId = $(this).data('gfBookingId');
	
	if ($("#terms").is(":checked")) {
		var form = $("#tourBookingForm");

		grecaptcha.ready(function () {
			// do request for recaptcha token
			// response is promise with passed token
			grecaptcha.execute('6Lfpx6whAAAAAJvpYIe2X4twQ6zHhfF_ZPxprfQr', { action: 'register_form' }).then(function (token) {
				// sessionStorage.setItem('token', token);
				
				$("input[name='g-recaptcha-response']").val(token);
				$("input[name='country_selected']").val($("#country_code").val());
				var formAction = form.attr('action');
				var formData = form.serialize();
				
				formData += "&firstname=" + encodeURIComponent($("input[name='first_name']").val());
				formData += "&lastname=" + encodeURIComponent($("input[name='last_name']").val());
				formData += "&postcode=" + encodeURIComponent($("input[name='billing_postcode']").val());
				formData += "&email=" + encodeURIComponent($("input[name='email_address']").val());
				formData += "&phone=" + encodeURIComponent($("input[name='phone']").val());
				formData += "&dob=" + encodeURIComponent($('#tourContactDOB').val());

				if (jQuery("#terms").prop("checked")) {
					// sessionStorage.setItem('terms', 1);	
					formData += "&terms=" + encodeURIComponent(1);
				}

				if (jQuery("#consent").prop("checked")) {
					// sessionStorage.setItem('consent', 1);	
					formData += "&consent=" + encodeURIComponent(1);
				}
				
				if (jQuery("#group_optin").prop("checked")) {
					// sessionStorage.setItem('consent', 1);	
					formData += "&group_optin=" + encodeURIComponent(1);
				}

				// handleSubmit(dataBookingId, dataPaymentId, dataGFBookingId);
				
				if (jQuery("#consent").prop("checked")) {
					
					$.ajax({
						type: "POST",
						// headers: {'Content-Type': 'application/x-www-form-urlencoded'},
						url: '/braze/book_tour.php',
						data: formData,
						dataType: "json",
						success: function (response) {
							console.log("The response register", response);
							
							handleSubmit(dataBookingId, dataPaymentId, dataGFBookingId);
						},
						error: function (jqXHR, exception) {
							console.log("Error on request", exception);
						}
					}).done(function (data) {
						console.log('FORM SUBMITTED');
					});
				} else {
					handleSubmit(dataBookingId, dataPaymentId, dataGFBookingId);
				}

			});
		});
	}
	
	// return false;
});
async function handleSubmit(bookingId, paymentId, gfBookingId) {
	//e.preventDefault();
	setLoading(true);
	
	// Get the path prefix to redirect the customer back to the same locale
	let returnPath = drupalSettings.path.pathPrefix;
	if (returnPath != "") {
	    returnPath = "/" + returnPath;
	} else {
		returnPath = "/";
	}


	const { error } = await stripe.confirmPayment({
		elements,
		confirmParams: {
			// Make sure to change this to your payment completion page
			return_url: domain_host +  returnPath + "book-tour?BookingId=" + bookingId + "&paymentId=" + paymentId + "&gfBookingId=" + gfBookingId,
		},
	});

	// This point will only be reached if there is an immediate error when
	// confirming the payment. Otherwise, your customer will be redirected to
	// your `return_url`. For some payment methods like iDEAL, your customer will
	// be redirected to an intermediate site first to authorize the payment, then
	// redirected to the `return_url`.
	if (error.type === "card_error" || error.type === "validation_error") {
		showMessage(error.message);
	} else {
		showMessage("An unexpected error occurred.");
	}
	setLoading(false);
}

// Fetches the payment intent status after payment submission
async function checkStatus() {
	const clientSecret = new URLSearchParams(window.location.search).get(
		"payment_intent_client_secret"
	);

	if (!clientSecret) {
		return;
	}

	const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

	switch (paymentIntent.status) {
		case "succeeded":
			showMessage("Payment succeeded!");
			break;
		case "processing":
			showMessage("Your payment is processing.");
			break;
		case "requires_payment_method":
			showMessage("Your payment was not successful, please try again.");
			break;
		default:
			showMessage("Something went wrong.");
			break;
	}
}

// ------- UI helpers -------

function showMessage(messageText) {
	const messageContainer = document.querySelector("#payment-message");

	messageContainer.classList.remove("hidden");
	messageContainer.textContent = messageText;

	//setTimeout(function () {
	//  messageContainer.classList.add("hidden");
	//  messageText.textContent = "";
	//}, 5000);
}

// Show a spinner on payment submission
function setLoading(isLoading) {
	if (isLoading) {
		// Disable the button and show a spinner
		jQuery(".stripe-submit").attr('disabled', true);
		// document.querySelector("#spinner").classList.remove("hidden");
		jQuery(".button-text").removeClass("hidden");
	} else {
		jQuery(".stripe-submit").attr('disabled', false);
		// document.querySelector("#spinner").classList.add("hidden");
		jQuery("#button-text").removeClass("hidden");
	}
}

sessionStorage.setItem('tour_instance_id', selectedTourInstance);
sessionStorage.setItem('tour_ticket_price', jQuery('#booking-summary tbody tr td #price').html());
sessionStorage.setItem('booking_date', selectedTourDate);
sessionStorage.setItem('quantity', selectedTourPlaces);
sessionStorage.setItem('first_name', formData['fname']);
sessionStorage.setItem('last_name', formData['lname']);
sessionStorage.setItem('email_address', formData['email']);
sessionStorage.setItem('telephone_num', formData['telephone']);
sessionStorage.setItem('billing_address_line_1', formData['addressline1']);
sessionStorage.setItem('billing_address_line_2', formData['addressline2']);
sessionStorage.setItem('billing_city', formData['city']);
sessionStorage.setItem('billing_state_province', formData['county']);
sessionStorage.setItem('billing_postcode', formData['postcode']);
sessionStorage.setItem('billing_country', formData['country']);
sessionStorage.setItem('marketing_consent', sessionStorage.getItem("marketing_consent"));
sessionStorage.setItem('return_path', '$AbsoluteLink');

function processBooking() {
	var tours_url = "https://" + url + "/booking/createbookingStripe";
	var theForm = document.getElementById('tourBookingForm');
	var tourId = $("#cboxLoadedContent #tourSelect").children('option:selected').val();
	createFormItem('g-recaptcha-response', "", "token");
	createFormItem('return_path', window.location.href.split('book')[0]);
	createFormItem('tour_name', jQuery("#cboxLoadedContent #tourSelect option:selected").text());
	createFormItem('tour_instance_id', jQuery('#tourTimeSelect').children('option:selected').val());
	createFormItem('booking_date', convertNormalDateFormat(jQuery('#tourDateInput').val()));
	createFormItem('quantity', jQuery('#tourPlacesSelect').val());
	createFormItem('tickets', '{\"tickets\":{\"0\":{\"id\":' + jQuery("#tour-place-label").attr('data-price-id') + ',\"qty\":' + selectedTourPlaces + ',\"name\":\"Adult\",\"price\":' + jQuery('#tour-place-label').attr('data-price') + '}}}');
	createFormItem('billing_address_line_1', jQuery('#tourAddress1Input').val());
	createFormItem('billing_address_line_2', jQuery('#tourAddress2Input').val());
	createFormItem('billing_postcode', jQuery('#tourPostcodeInput').val());
	createFormItem('billing_city', jQuery('#tourCityInput').val());
	createFormItem('billing_country', jQuery('#tourCountrySelect').val());
	createFormItem('email_address', jQuery('#tourContactEmailInput').val());
	createFormItem('first_name', jQuery('#tourContactFNameInput').val());
	createFormItem('last_name', jQuery('#tourContactLNameInput').val());
	createFormItem('telephone_num', jQuery('#tourContactTelephoneInput').val());
	createFormItem('billing_state_province', jQuery('#tourCountyInput').val());
	createFormItem('dietary_requirements', '');
	createFormItem('HPP_LANG', 'GB');
	createFormItem('price_id', jQuery("#tour-place-label").data('price-id'));

	sessionStorage.setItem('email_address', jQuery('#tourContactEmailInput').val());
	sessionStorage.setItem('first_name', jQuery('#tourContactFNameInput').val());
	sessionStorage.setItem('last_name', jQuery('#tourContactLNameInput').val());
	sessionStorage.setItem('dob', jQuery('#tourContactDOB').val());
	sessionStorage.setItem('postcode', jQuery('#tourPostcodeInput').val());
	sessionStorage.setItem('price_structure_value', jQuery('#tour-place-label').attr('data-price'));

	if (jQuery("#terms").prop("checked")) {
		sessionStorage.setItem('terms', 1);
	}

	if (jQuery("#consent").prop("checked")) {
		sessionStorage.setItem('consent', 1);
	}

	return $('#tourBookingForm').serializeArray();
	// theForm.submit();
}

function createFormItem(name, value, id = "") {
	var theForm = document.getElementById('tourBookingForm');
	var input1 = document.createElement('input');
	input1.setAttribute('type', 'hidden');
	input1.setAttribute('name', name);
	input1.setAttribute('value', value);
	if (id != "") {
		input1.setAttribute('id', id);
	}
	theForm.appendChild(input1);
}
function isValidEmailAddress(emailAddress) {
	var pattern = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,6})?$/;
	return pattern.test(emailAddress);
}
function isValidTelephone(telephone) {
	var pattern = /^[0-9+\- ]*$/;
	return pattern.test(telephone);
}